import { Component, effect, input, output } from "@angular/core";
import { DatePipe } from "@angular/common";
import { EvTooltipModule } from "ev-tooltip";
import { EvExpandedIconComponent } from "ev-expanded-icon";
import { AccordionIdentity, AccordionStateClass } from "../../models/accordion-state.class";
import { EvLogoLoaderComponent } from "src/app/shared-components/ev-logo-loader/ev-logo-loader.component";

@Component({
    selector: "infopage-accordion",
    templateUrl: "./info-page-accordion.component.html",
    styleUrl: "./info-page-accordion.component.scss",
    imports: [DatePipe, EvLogoLoaderComponent, EvTooltipModule, EvExpandedIconComponent],
})
export class InfoPageAccordionComponent {
    accordionState = input.required<AccordionStateClass<any>>();

    tooltipVisible: boolean = false;

    expanderClicked(): void {
        this.tooltipVisible = false;
        this.accordionState().expanderClicked();
    }

    toggleTooltip(e: any): void {
        e.preventDefault();
        e.stopPropagation();
        this.tooltipVisible = !this.tooltipVisible;
    }
}

export interface AccordionStateToolTip {
    header: string;
    content: string;
}
